module.exports = __webpack_public_path__ + "static/media/01-login-background-1024x1080.ac567798.jpg";